/**
 * 🚀 App.jsx
 * Router principal del panel administrativo Expande
 */
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import RoleProtectedRoute from "./routes/RoleProtectedRoute";
import { routeConfig } from "./routes/routeConfig";

import MainLayout from "./layouts/MainLayout";
import LoginPage from "./pages/LoginPage";
import DescargaAppPage from "./pages/DescargaApp/DescargaAppPage";
import DescargaSorteoPage from "./pages/DescargaApp/DescargaSorteoPage";
import ExpandeAppPage from "./pages/ExpandePublic/ExpandeAppPage";
import ExpandeSupportPage from "./pages/ExpandePublic/ExpandeSupportPage";
import ExpandePrivacyPage from "./pages/ExpandePublic/ExpandePrivacyPage";

import "./index.css";

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/*
           * Landings públicas del QR / feria.
           * SIN autenticación. No afectan al panel ni a su login.
           */}
          <Route
            path="/expande/app/descarga-oficial/sorteo"
            element={<DescargaSorteoPage />}
          />
          <Route
            path="/expande/app/descarga-oficial"
            element={<DescargaAppPage />}
          />
          <Route path="/expande/app" element={<ExpandeAppPage />} />
          <Route
            path="/expande/app/soporte"
            element={<ExpandeSupportPage />}
          />
          <Route
            path="/expande/app/privacidad"
            element={<ExpandePrivacyPage />}
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            {routeConfig.map((route) => {
              const element = (
                <RoleProtectedRoute allowedRoles={route.allowedRoles}>
                  <route.Component />
                </RoleProtectedRoute>
              );

              if (route.index) {
                return <Route key={route.id} index element={element} />;
              }

              return (
                <Route key={route.id} path={route.path} element={element} />
              );
            })}
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}
